import { render, staticRenderFns } from "./InlineKeyboardButton.vue?vue&type=template&id=959c6d0c"
import script from "./InlineKeyboardButton.vue?vue&type=script&lang=js"
export * from "./InlineKeyboardButton.vue?vue&type=script&lang=js"
import style0 from "./InlineKeyboardButton.vue?vue&type=style&index=0&id=959c6d0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports